export const STEP = {
  REGISTER_PARENT: 'registerParent',
  REGISTER_CHILD: 'registerChild',
  SIGNIN_PARENT: 'signInParent',
  LAUNCHER: 'launcher',
  CONNECT: 'connect',
};
